import React from 'react';
import {
  List,
  Responsive,
  Filter,
  TextInput,
  DateField,
  SimpleList,
  Datagrid,
  TextField,
  NumberField,
  EditButton,
  ReferenceInput,
  SelectInput,
  DateInput,
  ReferenceField
} from "react-admin";

export const PesajeFilter = props => (
  <Filter {...props}>
    <TextInput label="Bolsón" source="bolson" autoFocus />
    <TextInput label="Etapa" source="etapa" autoFocus />
    <TextInput label="Comentario" source="comentario" autoFocus />
    <TextInput label="Camión" source="camion" autoFocus />
    <ReferenceInput reference="pesadores" source="pesador" sort={{ field: 'nombre', order: 'ASC' }}>
        <SelectInput  optionText="nombre" />
    </ReferenceInput>
    <ReferenceInput
      label="Material"
      reference="materiales"
      source="material"
      filter={{enPesajes: true}}
      sort={{ field: 'nombre', order: 'ASC' }}
    >
      <SelectInput optionText="nombre" optionValue="_id" fullWidth />
    </ReferenceInput>
    <ReferenceInput reference="predios" source="predio">
      <SelectInput  optionText="nombre" optionValue="_id" />
    </ReferenceInput>
    <DateInput label="Fecha" source="fecha" autoFocus />
  </Filter>
);

export class PesajeListEditComponent extends React.Component {
  render() {
    const props = this.props;
    return(
        <List
          {...props}
          sort={{ field: "fecha", order: "DESC" }}
          filters={<PesajeFilter />}
          exporter={false}
        >
          <Responsive
            small={
              <SimpleList
                primaryText={record =>
                  "Fecha: " + new Date(record.fecha).toLocaleDateString("es-AR")
                }
                secondaryText={record =>
                  "Etapa: " + record.etapa + " Bolson: " + record.bolson
                }
                tertiaryText={record => record.peso + "Kgs."}
              />
            }
            medium={
              <Datagrid>
                <DateField label="Fecha" source="fecha" />
                <TextField label="Recuperador" source="cartoneroNombre" />
                <TextField label="D.N.I." source="dni" />
                <TextField source="etapa" />
                <NumberField label="Número de bolsón" source="bolson" />
                <NumberField label="Peso (Kgs.)" source="peso" />
                <ReferenceField label="Material" reference="materiales" source="material">
                  <TextField source="nombre" />
                </ReferenceField>
                <TextField label="Comentario" source="comentario" />
                <TextField label="Pesador" source="pesadorNombre" />
                <DateField label="Actualizado" source="updatedAt" />
                <EditButton />
              </Datagrid>
            }
          />
        </List>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Pesajes/PesajeListEditComponent.js